import React from 'react';
import classNames from 'classnames';

import { useAppSelector } from 'src/app/hooks';
import {
  selectIsFirstArea,
  selectLoaderComplete,
  selectSoundEnabled,
} from 'src/state';

import { Prompt } from './Prompt';
import { CreditsModal } from './CreditsModal';
import styles from './Overlay.module.css';

interface Props {}

export function LandingOverlay(props: Props) {
  const loadingComplete = useAppSelector(selectLoaderComplete);
  const isSoundEnabled = useAppSelector(selectSoundEnabled);
  const isFirstArea = useAppSelector(selectIsFirstArea);

  if (!isFirstArea) return null;

  // the landing cover gets dismissed when the user clicks anywhere
  const landingOverlayClasses = classNames(
    styles['landing-overlay'],
    {
      [styles['landing-overlay--loading']]: !loadingComplete || !isSoundEnabled,
    },
  );

  return (
    <div className={landingOverlayClasses} >
      <Prompt
        isFirstArea={isFirstArea}
        loadingComplete={loadingComplete}
      />
      <CreditsModal className={styles['landing-overlay__credits']}/>
    </div>
  );
}
